import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FiPlus, FiTrash, FiFolder } from 'react-icons/fi';
import { useParams, Link } from 'react-router-dom';
import LeadsStatisticsTwo from "../widgetsStatistics/LeadsStatisticsTwo";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const ModuleTableCreateHeader = () => {
  const { slug } = useParams();

  const [myPermissions, setMyPermissions] = useState([]);
  const [moduleInfo, setModuleInfo] = useState(null);

  const userLanguage = useUserLanguage();
  const { translations: trans } = useTranslations(userLanguage);
  const getText = (key, defaultValue) => trans[key] || defaultValue;

  // menuList.js ile aynı superadmin kontrolü
  const role = (localStorage.getItem("userRole") || "").toLowerCase();
  const isSuperAdmin = role === "superadmin";
const getLang = () => {
  return new URLSearchParams(window.location.search).get("lang") || "tr";
};

const withLang = (path) => {
  const lang = getLang();
  return `${path}?lang=${lang}`;
};
  useEffect(() => {
    fetchMyPermissions();
    fetchModuleInfo();
  }, [slug]);

  const fetchMyPermissions = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!resp.data || !Array.isArray(resp.data.permissions)) {
        console.error("API yanlış veri döndürdü:", resp.data);
        setMyPermissions([]);
      } else {
        setMyPermissions(resp.data.permissions);
      }
    } catch (error) {
      console.error("Permission bilgileri çekilemedi:", error);
      setMyPermissions([]);
    }
  };

  const fetchModuleInfo = async () => {
    try {
      const token = localStorage.getItem("admin_token");
      const resp = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/modules/by-slug/${slug}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      console.log("moduleInfo:", resp.data);
      setModuleInfo(resp.data);
    } catch (err) {
      console.error("Modül bilgisi alınamadı:", err);
    }
  };

  // menuList.js → getPermByModuleId ile aynı mantık: module_id ile eşleştir
  const currentModulePerm =
    myPermissions.find((p) => p.module_id === moduleInfo?.id) || {};

  // SuperAdmin her şeyi görebilir, diğerleri izne göre
  const canCreate =
    isSuperAdmin ||
    currentModulePerm.create_permission ||
    currentModulePerm.full_access;

  const canTrash =
    isSuperAdmin ||
    currentModulePerm.trash_permission ||
    currentModulePerm.full_access;

  // Kategori butonunu göstermek için hem modülde kategori aktif olmalı
  // hem de kullanıcının en az görüntüleme (sort_permission veya full_access) yetkisi olmalı
  const hasCategories = Number(moduleInfo?.category) === 1;
  const canSeeCategories =
    isSuperAdmin ||
    currentModulePerm.sort_permission ||
    currentModulePerm.full_access;

  return (
    <>
      <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">

        {hasCategories && canSeeCategories && (
          <Link
           to={withLang(`/modules/${slug}/category/list`)}
            className="btn btn-light-brand"
          >
            <FiFolder size={16} className="me-2" />
            <span>Kategoriler</span>
          </Link>
        )}

        {canCreate && slug && (
          <Link to={withLang(`/modules/${slug}/create`)} className="btn btn-primary">
            <FiPlus size={16} className="me-2" />
            <span>{getText("ROLE_CREATE_TITLE")}</span>
          </Link>
        )}

        {canTrash && slug && (
          <Link to={withLang(`/modules/${slug}/trash`)}className="btn btn-outline-danger">
            <FiTrash size={16} className="me-2" />
            <span>{getText("ROLE_TRASH_TITLE")}</span>
          </Link>
        )}

      </div>

      <div
        id="collapseOne"
        className="accordion-collapse collapse page-header-collapse"
      >
        <div className="accordion-body pb-2">
          <div className="row">
            <LeadsStatisticsTwo />
          </div>
        </div>
      </div>
    </>
  );
};

export default ModuleTableCreateHeader;